export const state = () => ({
  username: '',
})

export const mutations = {
  set: (state, username) => Object.assign(state, { username }),
}
